function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  d: "M437.022,74.984C388.67,26.63,324.381,0,256,0C187.624,0,123.338,26.63,74.984,74.984S0,187.624,0,256 c0,68.388,26.63,132.678,74.984,181.028C123.335,485.375,187.621,512,256,512c68.385,0,132.673-26.625,181.021-74.972 C485.372,388.679,512,324.389,512,256C512,187.623,485.372,123.336,437.022,74.984z M425.708,425.714 C380.381,471.039,320.111,496,256,496c-64.106,0-124.374-24.961-169.703-70.286C40.965,380.386,16,320.113,16,256 c0-64.102,24.965-124.37,70.297-169.703C131.63,40.965,191.898,16,256,16c64.108,0,124.378,24.965,169.708,70.297 C471.037,131.628,496,191.896,496,256C496,320.115,471.037,380.387,425.708,425.714z"
}), React.createElement("path", {
  d: "M430.038,114.969c-2.783-3.432-7.821-3.956-11.253-1.172c-3.431,2.784-3.956,7.822-1.172,11.252 C447.526,161.919,464,208.426,464,256c0,55.567-21.635,107.803-60.919,147.085C363.797,442.367,311.563,464,256,464 c-51.26,0-100.505-18.807-138.663-52.956c-3.292-2.946-8.35-2.666-11.296,0.626c-2.946,3.292-2.666,8.35,0.626,11.296 C147.763,459.745,200.797,480,256,480c59.837,0,116.089-23.297,158.394-65.601C456.701,372.095,480,315.84,480,256 C480,204.767,462.256,154.681,430.038,114.969z"
}), React.createElement("path", {
  d: "M48,256c0-114.691,93.309-208,208-208c51.26,0,100.504,18.808,138.662,52.959c3.293,2.948,8.351,2.666,11.296-0.625 c2.947-3.292,2.667-8.35-0.625-11.296C364.237,52.256,311.203,32,256,32c-59.829,0-116.08,23.301-158.389,65.611 C55.301,139.921,32,196.171,32,256c0,51.239,17.744,101.328,49.963,141.038c1.581,1.949,3.889,2.96,6.217,2.96 c1.771,0,3.553-0.585,5.036-1.788c3.431-2.784,3.956-7.822,1.172-11.253C64.474,350.088,48,303.58,48,256z"
}), React.createElement("path", {
  d: "M325.685,373.042h49.577c4.418,0,8-3.582,8-8v-85.508c0-24.007-6.204-42.903-18.439-56.162 c-11.438-12.395-27.571-18.947-46.653-18.947c-16.595,0-28.251,5.056-36.677,11.636v-0.138c0-4.418-3.582-8-8-8H223.93 c-2.185,0-4.274,0.894-5.784,2.473c-1.509,1.58-2.307,3.708-2.208,5.891c0.62,13.618-0.002,147.368-0.008,148.718 c-0.01,2.128,0.829,4.173,2.33,5.681c1.501,1.508,3.542,2.356,5.67,2.356h49.562c4.418,0,8-3.582,8-8V281.76 c0-4.336,0.347-7.376,1.053-9.092c1.594-3.953,6.54-13.146,18.02-13.146c4.683,0,17.121,0,17.121,25.734v79.785 C317.685,369.46,321.266,373.042,325.685,373.042z M300.564,243.522c-14.727,0-27.01,8.659-32.835,23.106 c-1.547,3.754-2.237,8.421-2.237,15.131v75.282h-33.526c0.111-25.855,0.418-105.46,0.123-133.119h33.403v13.117 c0,3.544,2.332,6.666,5.731,7.671c3.398,1.005,7.054-0.347,8.982-3.32c6.721-10.367,16.487-20.966,37.964-20.966 c31.199,0,49.093,21.544,49.093,59.108v77.508h-33.577v-71.785c0-12.136-2.428-21.855-7.216-28.887 C320.746,247.964,311.788,243.522,300.564,243.522z"
}), React.createElement("path", {
  d: "M207.747,169.605c-0.41-19.786-15.099-33.605-35.72-33.605C151.151,136,136,150.203,136,169.771 s14.877,33.771,35.375,33.771h0.333c20.883,0,36.041-14.203,36.041-33.771C207.749,169.716,207.748,169.661,207.747,169.605z  M171.708,187.542h-0.333c-11.589,0-19.375-7.142-19.375-17.771c0-10.629,8.048-17.771,20.026-17.771 c11.906,0,19.456,6.838,19.722,17.853C191.707,180.437,183.664,187.542,171.708,187.542z"
}), React.createElement("path", {
  d: "M146.919,207.922c-4.418,0-8,3.582-8,8v149.119c0,4.418,3.582,8,8,8h49.591c4.418,0,8-3.582,8-8V215.922 c0-4.418-3.582-8-8-8H146.919z M188.511,357.042h-33.591V223.922h33.591V357.042z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var _ref17 =
/*#__PURE__*/
React.createElement("g", null);

var Svg006Linkedin = function Svg006Linkedin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(Svg006Linkedin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/006-linkedin.c2b43ae0.svg";
export { ForwardRef as ReactComponent };